import { pick } from "lodash";

// Fields the server needs for a pickup's drop location. Anything else on the
// organization location object (e.g. scrapTypes) is stripped out.
export const DROP_LOCATION_FIELDS = [
  "_id",
  "nickname",
  "longitude",
  "latitude",
  "address",
];

export const toDropLocation = (location) =>
  pick(location || {}, DROP_LOCATION_FIELDS);
